import { meta } from '@/helpers/constants/router';
import { OVERVIEW_ROUTE, OVERVIEW_PRODUCTS_ROUTE, OVERVIEW_SALES_ROUTE, OVERVIEW_CUSTOMERS_ROUTE, PERFORMANCE_ROUTE, PERFORMANCE_POPULAR_PRODUCTS_ROUTE, PERFORMANCE_PROFITABLE_PRODUCTS_ROUTE, PRODUCTS_ROUTE, CATEGORIES_ROUTE, CART_SETTINGS_ROUTE, PROMOS_ROUTE, CART_PROMOS_ROUTE, CART_PROMOS_NEW_ROUTE, CART_PROMOS_EDIT_ROUTE, DELIVERY_AREAS_ROUTE, DELIVERY_AREAS_NEW_ROUTE, DELIVERY_AREAS_EDIT_ROUTE, SHIPPING_ROUTE, SHIPPING_NEW_ROUTE, SHIPPING_EDIT_ROUTE, PAYMENT_ROUTE, PROMOS_NEW_ROUTE, PROMOS_EDIT_ROUTE, ADDONS_ROUTE, ADDONS_NEW_ROUTE, ADDONS_EDIT_ROUTE, APPLICATIONS_ROUTE, ORDERS_ROUTE, ORDERS_HISTORY_ROUTE, BROADCAST_ROUTE, CUSTOMER_SEGMENT_ROUTE, CATEGORIES_NEW_ROUTE, CATEGORIES_EDIT_ROUTE, CATEGORIES_DETAILS_ROUTE, PRODUCTS_NEW_ROUTE, PRODUCTS_DETAILS_ROUTE, PRODUCTS_EDIT_ROUTE, } from '@/helpers/constants/B2bRoutes';
// lazy load components
// https://router.vuejs.org/guide/advanced/lazy-loading.html
const Wrapper = () => import('@/views/Wrapper.vue');
export default [
    {
        path: 'b2b',
        component: Wrapper,
        meta: { ...meta, title: 'Retail and Partnership' },
        children: [
            {
                path: 'products',
                component: Wrapper,
                redirect: PRODUCTS_ROUTE.name,
                meta: { ...meta, title: PRODUCTS_ROUTE.title },
                children: [
                    {
                        path: ':componentUUID',
                        component: Wrapper,
                        children: [
                            {
                                path: 'categories',
                                component: Wrapper,
                                meta,
                                children: [
                                    {
                                        path: '/',
                                        name: CATEGORIES_ROUTE.name,
                                        component: () => import('@/views/v2/b2b/Categories.vue'),
                                        meta: {
                                            title: CATEGORIES_ROUTE.title,
                                            subtitle: 'Customize, add, or manage your categories here. Drag and drop to arrange category sequence.',
                                            parentMenu: PRODUCTS_ROUTE.name,
                                        },
                                    },
                                    {
                                        path: 'create',
                                        name: CATEGORIES_NEW_ROUTE.name,
                                        component: () => import('@/views/v2/b2b/CategoryCreate.vue'),
                                        meta: {
                                            title: CATEGORIES_NEW_ROUTE.title,
                                            parentMenu: PRODUCTS_ROUTE.name,
                                        },
                                    },
                                    {
                                        path: ':uuid',
                                        meta: { title: CATEGORIES_ROUTE.title },
                                        component: Wrapper,
                                        children: [
                                            {
                                                path: 'edit',
                                                name: CATEGORIES_EDIT_ROUTE.name,
                                                component: () => import('@/views/v2/b2b/CategoryEdit.vue'),
                                                props: true,
                                                meta: {
                                                    title: CATEGORIES_EDIT_ROUTE.title,
                                                    parentMenu: PRODUCTS_ROUTE.name,
                                                },
                                            },
                                            {
                                                path: 'details',
                                                name: CATEGORIES_DETAILS_ROUTE.name,
                                                component: () => import('@/views/v2/b2b/CategoryDetails.vue'),
                                                props: true,
                                                meta: {
                                                    title: CATEGORIES_DETAILS_ROUTE.title,
                                                    parentMenu: PRODUCTS_ROUTE.name,
                                                },
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                path: '/',
                                name: PRODUCTS_ROUTE.name,
                                component: () => import('@/views/v2/ecommerce/Products.vue'),
                                meta: {
                                    title: PRODUCTS_ROUTE.title,
                                    parentMenu: PRODUCTS_ROUTE.name,
                                    subtitle: 'Customize product information such as product description, price and variances.',
                                },
                            },
                            {
                                path: 'create',
                                name: PRODUCTS_NEW_ROUTE.name,
                                component: () => import('@/views/v2/ecommerce/ProductsCreate.vue'),
                                meta: {
                                    title: PRODUCTS_NEW_ROUTE.title,
                                    parentMenu: PRODUCTS_ROUTE.name,
                                },
                            },
                            {
                                path: ':uuid',
                                component: Wrapper,
                                children: [
                                    {
                                        path: '/',
                                        name: PRODUCTS_DETAILS_ROUTE.name,
                                        component: () => import('@/views/v2/ecommerce/ProductDetails.vue'),
                                        props: true,
                                        meta: {
                                            title: PRODUCTS_DETAILS_ROUTE.title,
                                            parentMenu: PRODUCTS_ROUTE.name,
                                        },
                                    },
                                    {
                                        path: 'edit',
                                        name: PRODUCTS_EDIT_ROUTE.name,
                                        component: () => import('@/views/v2/ecommerce/ProductsEdit.vue'),
                                        props: true,
                                        meta: {
                                            title: PRODUCTS_EDIT_ROUTE.title,
                                            parentMenu: PRODUCTS_ROUTE.name,
                                        },
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
            {
                path: 'overview',
                component: Wrapper,
                meta: { ...meta, title: OVERVIEW_ROUTE.title },
                children: [
                    {
                        path: '/',
                        component: Wrapper,
                        meta: {
                            title: 'Overview',
                            redirect: OVERVIEW_ROUTE.name,
                        },
                        children: [
                            {
                                path: '/',
                                name: OVERVIEW_ROUTE.name,
                                component: () => import('@/views/v2/b2b/Overview.vue'),
                                meta: {
                                    title: OVERVIEW_ROUTE.title,
                                },
                            },
                            {
                                path: 'latest-sold-products',
                                name: OVERVIEW_PRODUCTS_ROUTE.name,
                                component: () => import('@/components/v2/ecommerce/LatestSoldProductsIndex.vue'),
                                meta: { title: OVERVIEW_PRODUCTS_ROUTE.title },
                            },
                            {
                                path: 'sales-amount',
                                name: OVERVIEW_SALES_ROUTE.name,
                                component: () => import('@/components/v2/ecommerce/SalesAmountIndex.vue'),
                                meta: { title: OVERVIEW_SALES_ROUTE.title },
                            },
                            {
                                path: 'latest-customers',
                                name: OVERVIEW_CUSTOMERS_ROUTE.name,
                                component: () => import('@/components/v2/ecommerce/LatestCustomersIndex.vue'),
                                meta: { title: OVERVIEW_CUSTOMERS_ROUTE.title },
                            },
                        ],
                    },
                    {
                        path: 'performance',
                        component: Wrapper,
                        meta: {
                            title: PERFORMANCE_ROUTE.title,
                            redirect: PERFORMANCE_ROUTE.name,
                        },
                        children: [
                            {
                                path: '/',
                                name: PERFORMANCE_ROUTE.name,
                                component: () => import('@/views/v2/b2b/Performance.vue'),
                                meta: {
                                    title: PERFORMANCE_ROUTE.title,
                                },
                            },
                            {
                                path: 'popular-producs',
                                name: PERFORMANCE_POPULAR_PRODUCTS_ROUTE.name,
                                component: () => import('@/views/v2/ecommerce/PopularProductList.vue'),
                                meta: {
                                    title: PERFORMANCE_POPULAR_PRODUCTS_ROUTE.title,
                                    parentMenu: PERFORMANCE_ROUTE.name,
                                },
                            },
                            {
                                path: 'most-sold-producs',
                                name: PERFORMANCE_PROFITABLE_PRODUCTS_ROUTE.name,
                                component: () => import('@/views/v2/ecommerce/ProfitableProductList.vue'),
                                meta: {
                                    title: PERFORMANCE_PROFITABLE_PRODUCTS_ROUTE.title,
                                    parentMenu: PERFORMANCE_ROUTE.name,
                                },
                            },
                        ],
                    },
                ],
            },
            {
                path: 'cart',
                component: Wrapper,
                redirect: CART_SETTINGS_ROUTE.name,
                meta: { ...meta, title: CART_SETTINGS_ROUTE.title },
                children: [
                    {
                        path: 'settings',
                        name: CART_SETTINGS_ROUTE.name,
                        component: () => import('@/views/v2/ecommerce/CartSetting.vue'),
                        meta: {
                            title: CART_SETTINGS_ROUTE.title,
                            parentMenu: CART_SETTINGS_ROUTE.name,
                            subtitle: 'Manage your cart settings such as Delivery Fee, Free Shipping, ' +
                                'Minimum Purchase Amount, Address Input and Location Scope.',
                        },
                    },
                    {
                        path: 'promos',
                        component: Wrapper,
                        redirect: CART_PROMOS_ROUTE.name,
                        meta: { title: CART_PROMOS_ROUTE.title },
                        children: [
                            {
                                path: '/',
                                name: CART_PROMOS_ROUTE.name,
                                component: () => import('@/views/v2/apps/CartPromos.vue'),
                                meta: {
                                    title: CART_PROMOS_ROUTE.title,
                                    parentMenu: CART_SETTINGS_ROUTE.name,
                                    subtitle: 'Set free shipping, set minimum purchase amount, and freebies',
                                },
                            },
                            {
                                path: 'create',
                                name: CART_PROMOS_NEW_ROUTE.name,
                                component: () => import('@/views/v2/apps/CartPromoCreate.vue'),
                                meta: {
                                    title: CART_PROMOS_NEW_ROUTE.title,
                                    parentMenu: CART_SETTINGS_ROUTE.name,
                                },
                            },
                            {
                                path: ':uuid',
                                component: Wrapper,
                                meta,
                                children: [
                                    {
                                        path: 'edit',
                                        name: CART_PROMOS_EDIT_ROUTE.name,
                                        props: true,
                                        component: () => import('@/views/v2/apps/CartPromoEdit.vue'),
                                        meta: {
                                            title: CART_PROMOS_EDIT_ROUTE.title,
                                            parentMenu: CART_SETTINGS_ROUTE.name,
                                        },
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
            {
                path: 'delivery-areas',
                component: Wrapper,
                redirect: DELIVERY_AREAS_ROUTE.name,
                meta: { ...meta, title: DELIVERY_AREAS_ROUTE.title },
                children: [
                    {
                        path: '/',
                        name: DELIVERY_AREAS_ROUTE.name,
                        component: () => import('@/views/v2/apps/DeliveryAreas.vue'),
                        meta: {
                            title: DELIVERY_AREAS_ROUTE.title,
                            subtitle: 'Manage your delivery locations',
                        },
                    },
                    {
                        path: 'create',
                        name: DELIVERY_AREAS_NEW_ROUTE.name,
                        component: () => import('@/views/v2/apps/DeliveryAreaCreate.vue'),
                        meta: { title: DELIVERY_AREAS_NEW_ROUTE.title },
                    },
                    {
                        path: ':uuid',
                        component: Wrapper,
                        meta,
                        children: [
                            {
                                path: 'edit',
                                name: DELIVERY_AREAS_EDIT_ROUTE.name,
                                props: true,
                                component: () => import('@/views/v2/apps/DeliveryAreaEdit.vue'),
                                meta: { title: DELIVERY_AREAS_EDIT_ROUTE.title },
                            },
                        ],
                    },
                ],
            },
            {
                path: 'shipping-methods',
                component: Wrapper,
                redirect: SHIPPING_ROUTE.name,
                meta: { ...meta, title: SHIPPING_ROUTE.title },
                children: [
                    {
                        path: '/',
                        name: SHIPPING_ROUTE.name,
                        component: () => import('@/views/v2/apps/ShippingMethods.vue'),
                        meta: { title: SHIPPING_ROUTE.title, subtitle: 'Manage your shipping methods' },
                    },
                    {
                        path: 'create',
                        name: SHIPPING_NEW_ROUTE.name,
                        component: () => import('@/views/v2/apps/ShippingMethodsCreate.vue'),
                        meta: { title: SHIPPING_NEW_ROUTE.title },
                    },
                    {
                        path: ':uuid',
                        component: Wrapper,
                        meta,
                        children: [
                            {
                                path: 'edit',
                                name: SHIPPING_EDIT_ROUTE.name,
                                props: true,
                                component: () => import('@/views/v2/apps/ShippingMethodsEdit.vue'),
                                meta: { title: SHIPPING_EDIT_ROUTE.title },
                            },
                        ],
                    },
                ],
            },
            {
                path: 'payment',
                redirect: PAYMENT_ROUTE.name,
                component: Wrapper,
                meta: { ...meta, title: PAYMENT_ROUTE.title },
                children: [
                    {
                        path: '/',
                        name: PAYMENT_ROUTE.name,
                        component: () => import('@/views/v2/Payments.vue'),
                        meta: {
                            title: PAYMENT_ROUTE.title,
                            subtitle: 'Manage your payment options',
                        },
                    },
                ],
            },
            {
                path: 'promos',
                component: Wrapper,
                redirect: PROMOS_ROUTE.name,
                meta: { ...meta, title: PROMOS_ROUTE.title },
                children: [
                    {
                        path: '/',
                        name: PROMOS_ROUTE.name,
                        component: () => import('@/views/v2/apps/PromoCodes.vue'),
                        meta: {
                            title: PROMOS_ROUTE.title,
                            subtitle: 'Manage promo codes, coupon expiration and limit',
                        },
                    },
                    {
                        path: 'create',
                        name: PROMOS_NEW_ROUTE.name,
                        component: () => import('@/views/v2/apps/PromoCodeCreate.vue'),
                        meta: { title: PROMOS_NEW_ROUTE.title },
                    },
                    {
                        path: ':uuid',
                        component: Wrapper,
                        meta,
                        children: [
                            {
                                path: 'edit',
                                name: PROMOS_EDIT_ROUTE.name,
                                props: true,
                                component: () => import('@/views/v2/apps/PromoCodeEdit.vue'),
                                meta: { title: PROMOS_EDIT_ROUTE.title },
                            },
                        ],
                    },
                ],
            },
            {
                path: 'add-ons',
                component: Wrapper,
                redirect: ADDONS_ROUTE.name,
                meta: { ...meta, title: ADDONS_ROUTE.title },
                children: [
                    {
                        path: '/',
                        name: ADDONS_ROUTE.name,
                        meta: {
                            title: ADDONS_ROUTE.title,
                            subtitle: 'Upsell your other services like gift wrapping, additional box and etc.',
                        },
                        component: () => import('@/views/v2/apps/CartAddOns.vue'),
                    },
                    {
                        path: 'create',
                        name: ADDONS_NEW_ROUTE.name,
                        component: () => import('@/views/v2/apps/CartAddOnsCreate.vue'),
                        meta: { title: ADDONS_NEW_ROUTE.title },
                    },
                    {
                        path: ':uuid',
                        component: Wrapper,
                        meta,
                        children: [
                            {
                                path: 'edit',
                                name: ADDONS_EDIT_ROUTE.name,
                                props: true,
                                component: () => import('@/views/v2/apps/CartAddOnsEdit.vue'),
                                meta: { title: ADDONS_EDIT_ROUTE.title },
                            },
                        ],
                    },
                ],
            },
            {
                path: 'applications',
                component: Wrapper,
                redirect: 'applications-by-status',
                meta: { ...meta, title: APPLICATIONS_ROUTE.title },
                children: [
                    {
                        path: ':status',
                        component: () => import('@/views/v2/b2b/Applications.vue'),
                        children: [
                            {
                                path: '/',
                                name: 'applications-by-status',
                                meta: { title: 'Applications' },
                                props: true,
                                component: () => import('@/views/v2/b2b/ApplicationsByStatus.vue'),
                            },
                            {
                                path: ':uuid',
                                name: 'view-application',
                                meta: { title: 'View Application' },
                                props: true,
                                component: () => import('@/views/v2/b2b/ApplicationDetails.vue'),
                            },
                        ],
                    },
                ],
            },
            {
                path: 'orders',
                component: Wrapper,
                redirect: ORDERS_ROUTE.name,
                meta: { ...meta, title: 'Orders' },
                children: [
                    {
                        path: 'history',
                        name: ORDERS_HISTORY_ROUTE.name,
                        meta: { title: ORDERS_HISTORY_ROUTE.title },
                        props: true,
                        component: () => import('@/views/v2/ecommerce/OrderHistory.vue'),
                    },
                    {
                        path: ':status/:filter?',
                        component: () => import('@/views/v2/b2b/Orders.vue'),
                        children: [
                            {
                                path: '/',
                                name: ORDERS_ROUTE.name,
                                meta: { title: ORDERS_ROUTE.title },
                                props: true,
                                component: () => import('@/views/v2/ecommerce/OrdersByStatus.vue'),
                            },
                        ],
                    },
                ],
            },
            {
                path: 'customers',
                component: Wrapper,
                meta: { ...meta, title: CUSTOMER_SEGMENT_ROUTE.title },
                children: [
                    {
                        path: '/',
                        name: CUSTOMER_SEGMENT_ROUTE.name,
                        meta: { title: CUSTOMER_SEGMENT_ROUTE.title },
                        component: () => import('@/views/v2/Customers.vue'),
                    },
                ],
            },
            {
                path: 'broadcast',
                component: Wrapper,
                meta: { ...meta, title: BROADCAST_ROUTE.title },
                children: [
                    {
                        path: '/',
                        name: BROADCAST_ROUTE.name,
                        meta: {
                            title: BROADCAST_ROUTE.title,
                            subtitle: 'Businesses will have up to 24 hours to respond to a user. Messages sent within the 24-hour window ' +
                                'may contain promotional content. We know people expect businesses to respond quickly, and ' +
                                'businesses that respond to users in a timely manner achieve better outcomes. We highly encourage ' +
                                'businesses to respond to people’s messages as soon as possible.',
                        },
                        component: () => import('@/views/v2/Broadcast.vue'),
                    },
                ],
            },
            {
                path: 'notifications',
                name: 'b2b-notifications',
                component: () => import('@/views/v2/NotificationsManager.vue'),
                meta: { ...meta, title: 'Notification Manager' },
                redirect: { name: 'b2b-notifications-manager-email' },
                children: [
                    {
                        path: 'fb-messenger',
                        name: 'b2b-notifications-manager-fb-messenger',
                        meta: { title: 'Notification Manager', parentMenu: 'b2b-notifications' },
                        component: () => import('@/views/v2/NotificationsFbMessenger.vue'),
                    },
                    {
                        path: 'email',
                        name: 'b2b-notifications-manager-email',
                        meta: { title: 'Notification Manager', parentMenu: 'b2b-notifications' },
                        component: () => import('@/views/v2/NotificationsEmail.vue'),
                    },
                ],
            },
        ],
    },
];
